// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__16rJn","text":"SelectPayment_text__1qh3B","title":"SelectPayment_title__s-E_u","btn":"SelectPayment_btn__3R-xF"};